import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {JhiAlertService, JhiEventManager} from 'ng-jhipster';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {
  IGuidelineDetail,
  ITieuChuan,
  SuppliesUsingEquipment,
} from '@entities/tieu-chuan/tieu-chuan.model';
import {TieuChuanService} from '@entities/tieu-chuan/tieu-chuan.service';
import {IActivityType} from '@entities/activity/activity.model';
// @ts-ignore
import * as moment from 'moment';

@Component({
  selector: 'app-activity-type-dialog',
  templateUrl: './activity-type-dialog.component.html',
  styleUrls: ['./activity-type-dialog.component.scss'],
})
export class ActivityTypeDialogComponent implements OnInit {
  isSaving: boolean;
  guideline: IGuidelineDetail;
  standard: ITieuChuan;
  guideType = 'NONG_NGHIEP'; // Default value, can be changed based on the context
  activityTypeDropdown: IActivityType[];
  activityParam: any;
  objectList: any;
  deviceOfUserCustomers: any;
  listChemical: any;
  listFertilizer: any;
  listSeed: any;
  listSuppliesInWarehouses: any;

  substratesData: any;
  constructor(
    private dialogRef: MatDialogRef<ActivityTypeDialogComponent>,
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private tieuChuanService: TieuChuanService,
    private translate: TranslateService,
  ) {
    this.isSaving = false;
    this.activityTypeDropdown = [];
    this.activityParam = [];
    this.objectList = [];
    this.deviceOfUserCustomers = [];
    this.listChemical = [];
    this.listFertilizer = [];
    this.listSeed = [];
    this.substratesData = [];
  }

  ngOnInit() {
    this.tieuChuanService
      .getActivityTypeDropdownV2(this.standard.guideType)
      .subscribe((res: any) => {
        this.activityTypeDropdown = res.body ? res.body : [];
      });
    // this.tieuChuanService.giaTheType().subscribe((res: any) => {
    //   this.substratesData = res.body ? res.body : [];
    // });
    // this.tieuChuanService.suppliesInWarehouses().subscribe((res: any) => {
    //   this.suppliesInWarehouses = res.body ? res.body : [];
    // });
    this.tieuChuanService.listDeviceOfUserCustomers().subscribe((res: any) => {
      this.deviceOfUserCustomers = res.body ? res.body : [];
    });
    // this.tieuChuanService.listSuppliesSeed().subscribe((res: any) => {
    //   this.listSeed = res.body ? res.body : [];
    // });
    // this.tieuChuanService.listSuppliesFertilizer().subscribe((res: any) => {
    //   this.listFertilizer = res.body ? res.body : [];
    // });
    // this.tieuChuanService.listSuppliesChemical().subscribe((res: any) => {
    //   this.listChemical = res.body ? res.body : [];
    // });
    if (this.guideline.id !== null) {
      this.objectList = [...this.guideline.tbGDObjectUpdateDTOList];
      this.guideline.tbGDObjectUpdateDTOList = [];
      this.titleService.setTitle(
        this.translate.instant(
          'entities.tieu-chuan.activity-type-dialog.Sửa hoạt động_title',
        ),
      );
      this.onChangeActivity(
        this.guideline.tbGuidelineActivityDTO.tbActivityTypeId,
        false,
      );
    } else {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.tieu-chuan.activity-type-dialog.Thêm hoạt động_title',
        ),
      );
    }
  }
  getSuppliesInWarehouses(group: string): void {
    this.tieuChuanService
      .listSuppliesInWarehouses(this.standard.guideType, group)
      .subscribe((res: any) => {
        this.listSuppliesInWarehouses = res.body ? res.body : [];
      });
  }
  onChangeActivity(event: any, isDropdown: boolean) {
    this.activityTypeDropdown.forEach((item) => {
      if (event === item.id) {
        this.guideline.tbGuidelineActivityDTO.isUseSupply = item.isUseSupply;
        return true;
      }
    });
    this.tieuChuanService
      .getDisplayObjectParamDynamicForm(event)
      .subscribe((res: any) => {
        this.activityParam = res.body ? res.body : [];
        this.guideline.tbGDObjectUpdateDTOList = [];
        if (isDropdown) {
          this.guideline.tbSuppliesUsingDetailsDTOs = [];
        }
        if (
          res.body.tbActivityTypeDTO &&
          res.body.tbActivityTypeDTO.supplyGroup
        ) {
          this.getSuppliesInWarehouses(res.body.tbActivityTypeDTO.supplyGroup);
        }
        res.body.objectParameterDTOList.forEach((item) => {
          const data =
            this.objectList.length > 0
              ? this.objectList.filter(
                  (obj) => obj.tbObjectParameterId === item.id,
                )
              : [];
          if (data.length > 0) {
            this.guideline.tbGDObjectUpdateDTOList.push({
              tbObjectParameterId: data[0].tbObjectParameterId,
              index: data[0].index,
              description: item.description,
              name: item.name,
              isMandatory: item.isMandatory,
              tbControlTypeName: item.tbControlTypeName,
              unit: item.unit,
              id: data[0].id,
              tbGuidelineActivityId: data[0].tbGuidelineActivityId,
              tbActivityExtendTypeExternalTable:
                item.tbActivityExtendTypeExternalTable,
              tbActivityExtendTypeCondition: item.tbActivityExtendTypeCondition,
            });
          } else {
            this.guideline.tbGDObjectUpdateDTOList.push({
              tbObjectParameterId: item.id,
              index: '',
              description: item.description,
              name: item.name,
              isMandatory: item.isMandatory,
              tbControlTypeName: item.tbControlTypeName,
              unit: item.unit,
              tbActivityExtendTypeExternalTable:
                item.tbActivityExtendTypeExternalTable,
              tbActivityExtendTypeCondition: item.tbActivityExtendTypeCondition,
            });
          }
        });
      });
  }
  save() {
    this.isSaving = true;
    const data = {...this.guideline};
    data.tbGDObjectUpdateDTOList.forEach((item, i) => {
      if (
        this.conditionInputDate(item.tbControlTypeName) &&
        item.index !== null
      ) {
        data.tbGDObjectUpdateDTOList[i].index = moment(
          item.index,
        ).toISOString();
      }
    });
    if (data.id !== null) {
      this.tieuChuanService
        .updateActivityGuidelineDetail(
          data.tbGuidelineActivityDTO.tbActivityTypeId,
          data,
        )
        .subscribe(
          (response) => this.onSaveSuccess(response),
          () => this.onSaveError(),
        );
    } else {
      this.tieuChuanService
        .createActivityGuidelineDetail(
          data.tbGuidelineActivityDTO.tbActivityTypeId,
          data,
        )
        .subscribe(
          (response) => this.onSaveSuccess(response),
          () => this.onSaveError(),
        );
    }
  }
  addUsing() {
    const data = new SuppliesUsingEquipment();
    this.guideline.tbSuppliesUsingDetailsDTOs = [
      ...this.guideline.tbSuppliesUsingDetailsDTOs,
      data,
    ];
  }
  removeUsing(index: number) {
    this.guideline.tbSuppliesUsingDetailsDTOs.splice(index, 1);
  }
  conditionExtend(name) {
    const arrExtend = [
      'ACTIVE_TYPE_SPRAYING_PESTICIDES',
      'ACTIVE_TYPE_FERTILIZE',
      'ACTIVE_TYPE_PLANTING',
    ];
    return arrExtend.includes(name);
  }
  conditionInputObject(type) {
    const arrType = ['radiobutton', 'dropdown'];
    return arrType.includes(type);
  }
  conditionInputDate(type) {
    const arrType = ['date', 'datetime', 'time'];
    return arrType.includes(type);
  }
  conditionDropdown(param, condition) {
    if (
      param.tbActivityExtendTypeExternalTable === 'tb_supplies' &&
      param.tbActivityExtendTypeCondition === condition
    ) {
      return true;
    } else {
      return false;
    }
  }
  private onSaveSuccess(result) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'activityDetailModification',
      content: 'guideline',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-activity-type-popup',
  template: '',
})
export class ActivityTypePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityTypeDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({guideline, standard}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(ActivityTypeDialogComponent, {
          disableClose: true,
          width: '500px',
        });
        this.dialogRef.componentInstance.guideline = guideline;
        this.dialogRef.componentInstance.standard = standard.guideline;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('common.title.Chi tiết quy trình'),
    );
    this.dialogRef = null;
  }
}
